import { Link } from 'react-router-dom';

type EmptyStateProps = {
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
};

export default function EmptyState({
  title,
  description,
  actionLabel = '返回首页',
  actionTo = '/',
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center border border-dashed border-background-300 bg-background-100/50 px-6 py-16 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-400">
        <i className="ri-file-search-line" />
      </span>
      <p className="mt-4 font-heading text-base text-foreground-800">{title}</p>
      {description && <p className="mt-2 max-w-sm text-sm leading-relaxed text-foreground-500">{description}</p>}
      {onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
        >
          {actionLabel}
        </button>
      ) : (
        <Link
          to={actionTo}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}